<script setup lang="ts">
defineProps<{
  withImage?: boolean
}>()

const mediaQuery = useMediaQuery()
</script>

<template>
  <ion-card class="os-skeleton-card">
    <os-row cross-axis-alignment="stretch">
      <os-skeleton-image
        v-if="withImage"
        :animated="true"
        class="os-skeleton-card__image"
      />

      <div class="os-skeleton-card__details">
        <os-skeleton-h1 />
        <os-expanded v-if="mediaQuery.isSmall" />
        <os-skeleton-p />
      </div>
    </os-row>
  </ion-card>
</template>

<style scoped>
.os-skeleton-card {
  background-color: var(--background--transparent);
}

.os-skeleton-card__image {
  width: 30% !important;
  flex-shrink: 0;
  display: inline;
  --border-radius: 0;
  flex-basis: auto;
}

.os-skeleton-card__details {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}
</style>
